/**
 * Whether the Planning P stepper is expanded, shared by Planning P and the
 * Planning Section Chief workspace.
 */
export const STEPPER_OPEN_STORAGE_KEY = 'planning-stepper-open';

export function readStepperOpenPreference(): boolean {
  try {
    const stored = sessionStorage.getItem(STEPPER_OPEN_STORAGE_KEY);
    if (stored === null) return true;
    return stored === 'true';
  } catch {
    return true;
  }
}

export function writeStepperOpenPreference(open: boolean): void {
  try {
    sessionStorage.setItem(STEPPER_OPEN_STORAGE_KEY, String(open));
  } catch {
    // ignore storage failures
  }
}
